import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export function NotFoundPage() {
  const { t } = useLanguage();
  return (
    <main className="not-found" id="main-content">
      <span>404</span>
      <h1>{t.notFound.title}</h1>
      <p>{t.notFound.body}</p>
      <Link className="button button-gold" to="/">{t.notFound.action}</Link>
    </main>
  );
}
